import { Checkbox, Divider, ListItemText, MenuItem } from '@mui/material';

interface SelectAllMenuItemProps {
  allIds: string[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export function SelectAllMenuItem({ allIds, selectedIds, onChange }: SelectAllMenuItemProps) {
  const allSelected = allIds.length > 0 && selectedIds.length === allIds.length;
  const indeterminate = selectedIds.length > 0 && selectedIds.length < allIds.length;

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          onChange(allSelected ? [] : allIds);
        }}
      >
        <Checkbox checked={allSelected} indeterminate={indeterminate} size='small' />
        <ListItemText primary='Select All' />
      </MenuItem>
      <Divider />
    </>
  );
}
